import { useQuery } from "@tanstack/react-query"

import { getCoachTodos } from "./api"
import { QueryKey } from "../../types/queries"
import { useUserQuery } from "../user/queries"

export const useCoachTodosQuery = () => {
  const { data: user } = useUserQuery()
  return useQuery({
    queryKey: [QueryKey.COACH_TODOS],
    queryFn: () => getCoachTodos(),
    enabled: !!user,
  })
}
